/**
 * Customized LogLevels that differ from the original Consola LogLevels
 * Info and Log have been switched so we can leave Info levels activated
 * without 'Log'ing everything.
 */
const LogLevel = {
	Error: 0,
	Warn: 1,
	Info: 2,
	Log: 3,
	Debug: 4,
	Trace: 5,
	Silent: -Infinity,
	Verbose: Infinity,
};

LogLevel[0] = 'Error';
LogLevel[1] = 'Warn';
LogLevel[2] = 'Info';
LogLevel[3] = 'Log';
LogLevel[4] = 'Debug';
LogLevel[5] = 'Trace';
LogLevel[-Infinity] = 'Silent';
LogLevel[Infinity] = 'Verbose';

export default LogLevel;
